var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Collapse",
    {
      staticClass: "tenant-submission-comment-history",
      attrs: {
        id: "comment-history-" + _vm.submission.id,
        expand: false,
        withBorder: false,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "comment-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v(_vm._s(_vm.$t("tenantProjects.reviewHistory")))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "comment-contents",
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c("div", { staticClass: "desgin-comment-content" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("tenantProjects.submission.cp"))),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "design-comment-text" }, [
              _c("pre", [
                _vm._v(_vm._s(_vm.designComment.description || "--")),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "design-comment-history" },
              _vm._l(_vm.designCommentHistory, function (rec) {
                return _c(
                  "div",
                  { key: rec.id, staticClass: "clearfix history-item" },
                  [
                    _c("div", { staticClass: "update-history__text" }, [
                      _vm._v(_vm._s(rec.user.displayName)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "update-history__text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.dateUtil.format(rec.updatedAt, "DD MMM YY HH:mm")
                        )
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tech-comment-content" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("tenantProjects.submission.pm"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tech-comment-history" },
              _vm._l(_vm.techCommentHistory, function (rec) {
                return _c(
                  "div",
                  { key: rec.id, staticClass: "clearfix history-item" },
                  [
                    _c("div", { staticClass: "update-history__text" }, [
                      _vm._v(_vm._s(rec.user.displayName)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "update-history__text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.dateUtil.format(rec.updatedAt, "DD MMM YY HH:mm")
                        )
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }